<template>
  <section class="form-page">
    <div class="consult-content">
      <div class="tel">{{ $t("联系我们") }}<br /></div>
      <div class="tel">{{ $t("项目咨询，可直接拨打") }}<br /></div>
      <a href="tel:+86-10-57590723" class="tel">+86-10-57590723</a><br />
      <a href="tel:+86-10-57590724">+86-10-57590724</a>
      <!-- <div class="desc">将体验到VIP顾问式售前咨询，提供个性化解决方案</div> -->
    </div>
    <div class="tips">
      *{{ $t("请填写以下表单，我们的销售代表会尽快与您联系") }}
    </div>
    <van-form @submit="submit">
      <van-cell-group inset>
        <van-field
          v-model="model.name"
          name="name"
          :label="$t('姓名')"
          :placeholder="$t('请填写')"
          :rules="[{ required: true, message: '' }]"
        />
        <van-field
          v-model="model.email"
          type="email"
          name="email"
          :label="$t('邮箱')"
          :placeholder="$t('请填写')"
          :rules="[{ required: true, message: '' }]"
        />
        <van-field
          v-model="model.password"
          name="password"
          :label="$t('密码')"
          :placeholder="$t('请填写')"
          :rules="[{ required: true, message: '' }]"
        />
        <van-field
          v-model="model.city"
          name="city"
          :label="$t('城市')"
          :placeholder="$t('请填写')"
          :rules="[{ required: true, message: '' }]"
        />
        <van-field
          v-model="model.telNumber"
          name="telNumber"
          :label="$t('电话')"
          :placeholder="$t('请填写')"
          :rules="[{ required: true, message: '' }]"
        />
        <van-field
          v-model="model.company"
          name="company"
          :label="$t('公司')"
          :placeholder="$t('请填写')"
          :rules="[{ required: true, message: '' }]"
        />
        <van-field
          v-model="model.profession"
          name="profession"
          :label="$t('行业')"
          :placeholder="$t('请填写')"
          :rules="[{ required: true, message: '' }]"
        />
        <van-field
          v-model="model.demand"
          type="textarea"
          rows="3"
          name="demand"
          :label="$t('需求')"
          :placeholder="$t('请填写')"
          :rules="[{ required: true, message: '' }]"
        />
      </van-cell-group>
      <div style="margin: 16px">
        <van-button round block type="primary" native-type="submit">
          {{ $t("提交") }}
        </van-button>
      </div>
    </van-form>
  </section>
</template>
<script>
import { Component, Vue } from "vue-property-decorator";
import { Debounce } from "@/common/decorators.js";
import { Toast } from "vant";
import i18n from "../../lang";
let defaultModel = {
  name: "",
  email: "",
  telNumber: "",
  city: "",
  company: "",
  profession: "",
};
@Component({ components: {} })
export default class Form extends Vue {
  model = {
    ...defaultModel,
  };
  @Debounce(300)
  submit(values) {
    this.api.customerInfo(values).then(() => {
      this.model = {}
      Toast.success(i18n.t("提交成功！我们会尽快与您联系"));
    });
    console.log("submit", values);
  }
}
</script>
<style lang="scss" scoped>
.form-page /deep/ {
  background-size: cover;
  background: #fff;
  text-align: left;
  margin-top: 1rem;
  padding-bottom: 20px;
  .consult-content {
    padding: 0.3rem;
    font-size: 0.6rem;
    width: 10rem;
    box-sizing: border-box;
  }
  .tips {
    font-size: 0.32rem;
    text-align: left;
    padding-left: 0.6rem;
  }
}
</style>
